import React, { useState } from "react";
import Popover, { PopoverOrigin } from '@mui/material/Popover';

/**
 * A dropdown component reimplemented using Material-UI's Popover.
 * This component is a wrapper around MUI's Popover to provide a simpler interface
 * for creating dropdowns with a toggle button.
 */
export default function Dropdown(props: {
    toggleButton: React.ReactNode,
    children: React.ReactNode,
    width?: string,
    keepMounted?: boolean,
    anchorOrigin?: PopoverOrigin,
    transformOrigin?: PopoverOrigin,
    closeOnItemClick?: boolean,
}) {
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        // Prevent parent click listeners, which might close other popovers.
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'mui-dropdown-popover' : undefined;

    return (
        <>
            <span aria-describedby={id} onClick={handleClick} className="my-auto" style={{ cursor: 'pointer' }}>
                {props.toggleButton}
            </span>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                onClick={(e) => e.stopPropagation()} // Prevent clicks inside from closing the popover via window listeners.
                keepMounted={props.keepMounted}
                anchorOrigin={props.anchorOrigin}
                transformOrigin={props.transformOrigin}
                PaperProps={{
                    style: {
                        width: props.width,
                        boxShadow: "0 0 6px rgba(0, 0, 0, 0.5)",
                    },
                }}
            >
                <div style={{ padding: '8px' }} onClick={props.closeOnItemClick ? handleClose : undefined}>
                    {props.children}
                </div>
            </Popover>
        </>
    );
}